import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { UserPrivilegeEnum } from '../../../../enums/rights/user-privilege.enum';
import { RCostType } from './r-cost-type.action';
import { ResetStateDefaults } from '../../../base-action-class.model';

interface RCostTypeXsStateModel {
  viewGlobalCostType: string;
  createGlobalCostType: string;
  editGlobalCostType: string;
  deleteGlobalCostType: string;
}

const getDefaults = (): RCostTypeXsStateModel => ({
  viewGlobalCostType: null,
  createGlobalCostType: null,
  editGlobalCostType: null,
  deleteGlobalCostType: null
});

@State<RCostTypeXsStateModel>({
  name: 'rCostType',
  defaults: getDefaults()
})
@Injectable()
export class RCostTypeXsState {

  //region SELECTOR
  @Selector()
  static canViewGlobalCostType(state: RCostTypeXsStateModel): boolean {
    return state.viewGlobalCostType != null;
  }

  @Selector()
  static canCreateGlobalCostType(state: RCostTypeXsStateModel): boolean {
    return state.createGlobalCostType != null;
  }

  @Selector()
  static canEditGlobalCostType(state: RCostTypeXsStateModel): boolean {
    return state.editGlobalCostType != null;
  }

  @Selector()
  static canDeleteGlobalCostType(state: RCostTypeXsStateModel): boolean {
    return state.deleteGlobalCostType != null;
  }

  //endregion

  //region ACTIONS
  @Action(RCostType.SetCostTypePrivileges)
  public setJobCategoryPrivileges(ctx: StateContext<RCostTypeXsStateModel>, action: RCostType.SetCostTypePrivileges) {
    const state = ctx.getState();
    const designationPrivileges = [...action.activeUserRightInfoDtoModel.designationPrivileges];

    //find user privilege data model
    const viewGlobalCostType = designationPrivileges.find(id => id === UserPrivilegeEnum.VIEW_GLOBAL_COST_TYPE);
    const createGlobalCostType = designationPrivileges.find(id => id === UserPrivilegeEnum.CREATE_GLOBAL_COST_TYPE);
    const editGlobalCostType = designationPrivileges.find(id => id === UserPrivilegeEnum.EDIT_GLOBAL_COST_TYPE);
    const deleteGlobalCostType = designationPrivileges.find(id => id === UserPrivilegeEnum.DELETE_GLOBAL_COST_TYPE);

    //set the state
    ctx.setState({
      ...state,
      viewGlobalCostType: viewGlobalCostType,
      createGlobalCostType: createGlobalCostType,
      editGlobalCostType: editGlobalCostType,
      deleteGlobalCostType: deleteGlobalCostType
    });
  }

  @Action(ResetStateDefaults)
  public resetDefaults(ctx: StateContext<RCostTypeXsStateModel>): void {
    ctx.setState({ ...getDefaults() });
  }

  //endregion
}
